import { Controller, useFormContext } from 'react-hook-form'
import { Label } from '@/components/ui/label'
import { MultiImageUploader } from '@/components/ui/MultiImageUploader'
import { ProductModel } from '@/types/model/Product'

interface VariantMediaGalleryProps {
    index: number
}

export const VariantMediaGallery = ({ index }: VariantMediaGalleryProps) => {
    const { control } = useFormContext<ProductModel.ProductFormData>()

    return (
        <div className="space-y-1.5">
            <Label>Media</Label>
            <Controller
                control={control}
                name={`variations.${index}.images`}
                render={({ field: imageField, fieldState: { error } }) => (
                    <div className="space-y-1.5">
                        <MultiImageUploader
                            value={imageField.value || []}
                            onChange={imageField.onChange}
                            maxImages={20}
                        />
                        {error && <p className="text-sm text-error">{error.message}</p>}
                    </div>
                )}
            />
        </div>
    )
}
